export enum LLMStyle {
    REGULAR="REGULAR",
    SMART="SMART",
    FASTEST="FASTEST",
    CONVERSATIONAL ="CONVERSATIONAL"
}
